import React, { useContext, useEffect, useRef, useState } from "react";
import RGBColorPicker from "./color-pickers/RGBColorPicker";
import "./Rgb.css";
import LinearSlider from "./Sliders/LinearSlider";
import { Context } from "../../../context/Context";

const RGB = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    equipmentButtons,
    devices,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);
  const [color, setColor] = useState({ r: 255, g: 255, b: 255 });
  const [brightness, setBrightness] = useState(100);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickChangeColor = (red, green, blue) => {
    setColor({ r: red, g: green, b: blue });
  };

  const handleChangeBrightness = (value) => {
    setBrightness(Number(value));
  };

  const handleSubmit = () => {
    const button = buttons[0];
    let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
    if (button.digit == 0) {
      selectedChannel[selectedChannel.length - (button.digit + 1)] = "1";
      selectedChannel[selectedChannel.length - (button.digit + 2)] = "1";
      selectedChannel[selectedChannel.length - (button.digit + 3)] = "1";
    } else if (button.digit == 1) {
      selectedChannel[selectedChannel.length - (button.digit + 4)] = "1";
      selectedChannel[selectedChannel.length - (button.digit + 5)] = "1";
      selectedChannel[selectedChannel.length - (button.digit + 6)] = "1";
    }
    let data1 = parseInt(selectedChannel.join(""), 2);
    let data2 = button.digit == 0 ? color.r : 0;
    let data3 = button.digit == 0 ? color.g : 0;
    let data4 = button.digit == 0 ? color.b : 0;
    let data5 = button.digit == 1 ? color.r : 0;
    let data6 = button.digit == 1 ? color.g : 0;
    let data7 = button.digit == 1 ? color.b : 0;
    let data8 = 101;
    let data9 = 101;
    let data10 = button.digit == 0 ? brightness : 101;
    let data11 = button.digit == 1 ? brightness : 101;

    if (scenarioCommandDetail.id) {
      // setIsLoading(true);
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: data1,
                data2: data2,
                data3: data3,
                data4: data4,
                data5: data5,
                data6: data6,
                data7: data7,
                data8: data8,
                data9: data9,
                data10: data10,
                data11: data11,
                command_name: String(button.name),
                icon: button.icon,
              }
            : command
        )
      );
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // UpdateScenarioCommand({
      //   scenario_command_id: scenarioCommandDetail.id,
      //   device_id: button.device_id,
      //   time: scenarioCommandDetail.time,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   data5: data5,
      //   data6: data6,
      //   data7: data7,
      //   data8: data8,
      //   data9: data9,
      //   data10: data10,
      //   data11: data11,
      //   command_name: button.name,
      //   icon: button.icon,
      // }).then(({ data: sData }) => {
      //   SuccessToast("دستور با موفقیت جایگزین شد");
      //   const newScenarioCommands = scenarioCommands.map((scn) => {
      //     if (scn.id === scenarioCommandDetail.id) {
      //       return {
      //         ...scn,
      //         device_id: button.device_id,
      //         time: scenarioCommandDetail.time,
      //         data1: data1,
      //         data2: data2,
      //         data3: data3,
      //         data4: data4,
      //         data5: data5,
      //         data6: data6,
      //         data7: data7,
      //         data8: data8,
      //         data9: data9,
      //         data10: data10,
      //         data11: data11,
      //         command_name: button.name,
      //         icon: button.icon,
      //       };
      //     }
      //     return scn;
      //   });
      //   setScenarioCommands(newScenarioCommands);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    } else {
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: data1,
          data2: data2,
          data3: data3,
          data4: data4,
          data5: data5,
          data6: data6,
          data7: data7,
          data8: data8,
          data9: data9,
          data10: data10,
          data11: data11,
          command_name: String(button.name),
          icon: button.icon,
          device_id: button.device_id,
          time: 500,
        },
      ]);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // setIsLoading(true);
      // CreateScenarioCommand({
      //   scenario_id: addScenarioCommandDetail.scenario_id,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   data5: data5,
      //   data6: data6,
      //   data7: data7,
      //   data8: data8,
      //   data9: data9,
      //   data10: data10,
      //   data11: data11,
      //   command_name: button.name,
      //   icon: button.icon,
      //   device_id: button.device_id,
      //   time: 500,
      // }).then(({ data }) => {
      //   SuccessToast("دستور با موفقیت اضافه گردید");
      //   setScenarioCommands([...scenarioCommands, data.scenario_command]);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    }
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        <div className="rgb">
          <div className="text-center">
            <div className="text-center">
              <p className="text-center p-0 m-0 d-block">
                {buttons?.[0]?.name}
              </p>
            </div>
            <div className="text-center">
              <span style={{ fontSize: "11px" }}>
                C{buttons?.[0] ? buttons?.[0].digit + 1 : "-"}-S/
                {buttons?.[0]
                  ? devices.find((d) => d.id == buttons[0]?.device_id)?.serial
                  : "-"}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column">
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(0, 0, 0)}
              >
                <img src="/assets/img/app-icons/zl.png" alt="" />
              </div>
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(255, 255, 255)}
              >
                <img src="/assets/img/app-icons/v8.png" alt="" />
              </div>
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(255, 255, 0)}
              >
                <img src="/assets/img/app-icons/_o.png" alt="" />
              </div>
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(255, 0, 255)}
              >
                <img src="/assets/img/app-icons/hM.png" alt="" />
              </div>
            </div>
            <div>
              <RGBColorPicker color={color} setColor={handleClickChangeColor} />
            </div>
            <div className="d-flex flex-column">
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(255, 0, 0)}
              >
                <img src="/assets/img/app-icons/gN.png" alt="" />
              </div>
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(0, 255, 0)}
              >
                <img src="/assets/img/app-icons/gQ.png" alt="" />
              </div>
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(0, 0, 255)}
              >
                <img src="/assets/img/app-icons/ht.png" alt="" />
              </div>
              <div
                className="icons my-1"
                onClick={() => handleClickChangeColor(0, 255, 255)}
              >
                <img src="/assets/img/app-icons/hR.png" alt="" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <div className="icons">
              <img src="/assets/img/app-icons/CE.png" alt="" />
            </div>
            <div className="slider">
              <LinearSlider
                value={brightness}
                setValue={(value) => handleChangeBrightness(value)}
              />
            </div>
            <div className="icons">
              <img src="/assets/img/app-icons/4W.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(RGB);
